import { Container, TextField, Button, Box, Paper, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as endPoints from '../assets/js/endpoints';
import Loader from '../components/loader';
import { useEffect, useState } from 'react';
import { useNotification } from '../assets/contexts/notificationContext';
import { Helmet } from 'react-helmet';

const CreateCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '' });

  useEffect(() => {
    if (id) {
      setLoading(true);
      endPoints.getCategory(id)
        .then(data => {
          setForm({ name: data.name || '' });
        })
        .catch(err => {
          showNotification('Error cargando categoría', 'error');
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      if (id) {
        await endPoints.updateCategory(id, form);
        showNotification('Categoría actualizada', 'success');
      } else {
        await endPoints.createCategory(form);
        showNotification('Categoría creada', 'success');
      }
      navigate('/admin/manageCategories');
    } catch (err) {
      const msg = err.response?.data?.error || 'Error guardando categoría';
      showNotification(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <>
      <Helmet>
        <title>{id ? 'Actualizar Categoría' : 'Crear Categoría'} | CES</title>
      </Helmet>
      <Container sx={{ mt:5, pb:2, mb:2 }}>
        <Paper sx={{ p:3, maxWidth: 600, mx:'auto' }}>
          <Typography variant='h5' gutterBottom sx={{mb:3}}>
            {id ? 'Actualizar Categoría' : 'Crear Categoría'}
          </Typography>
          <Box component='form' onSubmit={handleSubmit} sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          maxWidth: 400,
          mx: 'auto',
          mb: 2,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <TextField label='Nombre' name='name' value={form.name} onChange={handleChange} required sx={{ gridColumn: '1 / -1' }} />
            <Box sx={{ gridColumn: '1 / -1', display: 'flex', justifyContent: 'center' }}>
              <Button type='submit' variant='contained'>
                {id ? 'Actualizar' : 'Crear'} Categoría
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default CreateCategory;
